import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useAuth } from "../../auth/store";
import { notificationsApi, notifyKeys } from "./api";

/** Unread-count bell for the Shell header. Polls every 30 s. */
export function InboxBell() {
  const orgId = useAuth().currentOrgId ?? "";
  const inbox = useQuery({ queryKey: notifyKeys.inboxCount(orgId), queryFn: () => notificationsApi.inbox(orgId, { limit: 1 }), enabled: !!orgId, refetchInterval: 30_000 });
  const unread = inbox.data?.unread ?? 0;
  return (
    <Link to={"/inbox" as never} className="btn ghost icon-btn bell" aria-label={unread ? `Inbox, ${unread} unread` : "Inbox"}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 9a6 6 0 1 1 12 0c0 4 1 6 2 7H4c1-1 2-3 2-7z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
        <path d="M10 20a2 2 0 0 0 4 0" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      </svg>
      {unread > 0 && <span className="bell-count">{unread > 99 ? "99+" : unread}</span>}
    </Link>
  );
}
